import { computed } from 'vue';
import { message } from 'ant-design-vue';
import { useAuthStore } from '@/stores/auth.store';
import { useWorkspaceStore } from '@/stores/workspace.store';
import { useWorkspaceHomeNavigation } from './useWorkspaceHomeNavigation';

/**
 * 工作区侧栏（rail + context）折叠状态的统一来源。
 *
 * - workspaceId 缺省时从 workspace/auth store 兜底（用于文件/知识库/设置等顶层页面）；
 *   工作台/聊天页面可显式传入路由参数取值函数。
 * - toggleSidebar 将折叠偏好持久化到用户档案，失败时提示。
 */
export function useWorkspaceSidebarCollapse(workspaceId?: () => string) {
  const auth = useAuthStore();
  const workspace = useWorkspaceStore();
  const resolvedWorkspaceId = computed(() => {
    if (workspaceId) return workspaceId();
    const selectedId = workspace.currentWorkspaceId ?? auth.user?.lastWorkspaceId;
    return selectedId && workspace.entities[selectedId]
      ? selectedId
      : (Object.keys(workspace.entities)[0] ?? '');
  });
  const homeNavigation = useWorkspaceHomeNavigation(() => resolvedWorkspaceId.value);
  const sidebarCollapsed = computed(() => auth.user?.workspaceSidebarCollapsed === true);

  function toggleSidebar(): void {
    void homeNavigation
      .setCollapsed(!sidebarCollapsed.value)
      .catch((cause) => message.error((cause as { message?: string }).message ?? '侧栏偏好保存失败'));
  }

  return { workspaceId: resolvedWorkspaceId, sidebarCollapsed, toggleSidebar };
}
